module.exports = __webpack_public_path__ + "static/media/30-min.33f90c76.png";